module.exports = __webpack_public_path__ + "img/bgtop1.ed43ac53.jpg";